var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEventsNumber(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_80_20",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 39,
    height: 39
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 39,
    height: 39,
    fill: "#C32428"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_80_20)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.625 35.75V30.875H22.75V27.625H27.625V22.75H30.875V27.625H35.75V30.875H30.875V35.75H27.625ZM8.125 32.5C7.23125 32.5 6.46615 32.1818 5.82969 31.5453C5.19323 30.9089 4.875 30.1437 4.875 29.25V9.75C4.875 8.85625 5.19323 8.09115 5.82969 7.45469C6.46615 6.81823 7.23125 6.5 8.125 6.5H9.75V3.25H13V6.5H22.75V3.25H26V6.5H27.625C28.5187 6.5 29.2839 6.81823 29.9203 7.45469C30.5568 8.09115 30.875 8.85625 30.875 9.75V19.6625C30.3333 19.5813 29.7917 19.5406 29.25 19.5406C28.7083 19.5406 28.1667 19.5813 27.625 19.6625V16.25H8.125V29.25H19.5C19.5 29.7917 19.5406 30.3333 19.6219 30.875C19.7031 31.4167 19.8521 31.9583 20.0688 32.5H8.125Z",
    fill: "#C32428"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEventsNumber);
export default __webpack_public_path__ + "static/media/EventsNumber.a3bfdfdb2fb30764d10858fdff2bb694.svg";
export { ForwardRef as ReactComponent };